import React from 'react'

import { useMemberInsights } from './hooks/use-member-insights'
import { MemberInsightsTemplate } from './template'

const MemberInsights = (): React.JSX.Element => {
  const state = useMemberInsights()

  return <MemberInsightsTemplate state={state} />
}

export default MemberInsights
